import { Box } from "@mui/material";
import { Form } from "react-bootstrap";

const TextInput = (props) => {
  const { name, label, register, errors, disabled = false, type = "text", className = "" } = props;

  return (
    <Box className={errors ? "mb-1" : "mb-3"}>
      <Form.Label htmlFor={name}>{label}</Form.Label>
      <Form.Control
        type={type}
        disabled={disabled}
        id={name}
        name={name}
        {...register(name)}
        className={"form-control " + (errors ? " border border-danger " : "") + className}
        onWheel={(e) => {
          if (type === "number") e.target.blur();
          return;
        }}
      />
      {errors && <small className='text-danger mb-0 fw-semibold mt-2'>{errors?.message}</small>}
    </Box>
  );
};

export default TextInput;
